// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__vNHbS","container":"styles_container__1xn9R","title":"styles_title__1p-rX","wrapper":"styles_wrapper__BX28s","answer":"styles_answer__1mzrG"};